var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaretRightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08464 4.41927L13.0846 9.41927C13.2513 9.58594 13.3346 9.7526 13.3346 10.0026C13.3346 10.2526 13.2513 10.4193 13.0846 10.5859L8.08464 15.5859C7.7513 15.9193 7.2513 15.9193 6.91797 15.5859C6.58464 15.2526 6.58464 14.7526 6.91797 14.4193L11.3346 10.0026L6.91797 5.58594C6.58464 5.2526 6.58464 4.7526 6.91797 4.41927C7.2513 4.08594 7.7513 4.08594 8.08464 4.41927Z",
    fill: "#4F4F4F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6690_50460",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 8,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08464 4.41927L13.0846 9.41927C13.2513 9.58594 13.3346 9.7526 13.3346 10.0026C13.3346 10.2526 13.2513 10.4193 13.0846 10.5859L8.08464 15.5859C7.7513 15.9193 7.2513 15.9193 6.91797 15.5859C6.58464 15.2526 6.58464 14.7526 6.91797 14.4193L11.3346 10.0026L6.91797 5.58594C6.58464 5.2526 6.58464 4.7526 6.91797 4.41927C7.2513 4.08594 7.7513 4.08594 8.08464 4.41927Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6690_50460)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20L0 0H20V20H0Z",
    fill: "#828282"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRightIcon);
export default __webpack_public_path__ + "static/media/CaretRightIcon.b9df07bdc762a1884f05733b809485f5.svg";
export { ForwardRef as ReactComponent };